import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { AppComponent } from '../../../shared';
import { AppModule } from './app/app.module';

bootstrapApplication(AppComponent, {
  providers: [provideZoneChangeDetection(), importProvidersFrom(AppModule), provideCharts(withDefaultRegisterables())]
}).catch((err) => console.error(err));
